import { TElement, TText } from '@udecode/plate-core';

/*
export enum BLOCK_ELEMENT_KEY {
  TEXT = 'text',
  HREF = 'href',
  URL = 'url',
  BACKGROUND_IMAGE = 'backgroundImage',
  HTML = 'html',
  FILE = 'file',
  COLLECTION_TEMPLATE = 'collection_template',
  COLLECTION_DEFAULT_ITEM_PAGE_TEMPLATE_KEY = 'collection_default_item_page_template_key',
  COLLECTION_DATA_ID = 'collection_data_id', // reference to data setup that is saved in space.customization

  WIDTH = 'width',
  HEIGHT = 'height',
  ASPECT_RATIO = 'aspect_ratio',

  OPEN_IN_NEW_TAB = 'open_in_new_tab',
  INTERNAL_LINK = 'internal_link',
  // For COLLECITON_ITEM
  COLLECTION_ITEM_ID = 'collection_item_id', // the data id from the table for the current COLLECTION_ITEM
  COLLECTION_ITEM_PAGE_ID = 'collection_item_page_id', // the page id for the item page template for this collection item

  // COLLECTION_CONNECT_DATA and COLLECTION_DATA_SCHEMA_KEY
  // would be part of normal elements that are inside of a collection_template.template
  COLLECTION_CONNECT_DATA = 'collection_connect_data', // boolean, whether or not this element should be connected to a data source
  COLLECTION_CONNECT_DATA_KEYS = 'collection_connect_data_keys', // array of connection setups [{schemaKey: 'title', blockElementKey: 'text'}]
}

*/

export enum BLOCK_ELEMENT_KEY {
  TEXT = 'text',
  HREF = 'href',
  OPEN_OPTIONS = 'openOptions',
  OPTION_INDEX = 'optionIndex',
  CODE_LANGUAGE = 'code_language',
  URL = 'url', // image src / as href
  WIDTH = 'width',
  HEIGHT = 'height',
  WIDTH_MAX = 'width_max', // if width was set to 100%
  BACKGROUND = 'background',
  BACKGROUND_IMAGE = 'backgroundImage',
  BACKGROUND_DARKEN = 'backgroundDarken',
  BACKGROUND_VIDEO = 'backgroundVideo',
  COLOR = 'color',
  GRADIENT = 'gradient',
  ALIGN = 'align',
  VERTICAL_ALIGN = 'vertical_align',
  STYLE = 'style', // universal style name that can be interpreted by individual block type
  ICON = 'icon', // for buttons
  HTML = 'html', // for embed
  FILE = 'file', // for embed
  KEEP_ASPECT_RATIO = 'keep_aspect_ratio', // for embed
  ASPECT_RATIO = 'aspect_ratio',
  ALT_TEXT = 'alt_text',
  CHECKED = 'checked', // for todo_list

  // for internal page linking
  INTERNAL_LINK = 'internal_link',
  PAGE_ID = 'page_id',
  OPEN_IN_NEW_TAB = 'open_in_new_tab',
  // Collection Internal linking
  COLLECTION_LINK_SLUG = 'collection_link_slug',
  COLLECTION_LINK_DATA_ID = 'collection_link_data_id',
  COLLECTION_INTERNAL_LINK = 'collection_internal_link',

  MOBILE_HIDE = 'mobile_hide',
  DESKTOP_HIDE = 'desktop_hide',
  MOBILE_DIRECTION = 'mobile_direction',
  MOBILE_REVERSE_COLUMNS = 'mobile_reverse_columns',
  MOBILE_HORIZONTAL_OVERFLOW = 'mobile_horizontal_overflow',
  ANIMATION = 'animation',
  TRANSCLUSION_ENABLED = 'transclusion_enabled', // for transclusion
  TRANSCLUSION_REFERENCE_ID = 'transclusion_reference_id', // for transclusion
  TRANSCLUSION_UPDATED_AT = 'transclusion_updated_at', // for transclusion

  // COLLECTION_TEMPLATE would be part of the type:collection block
  // template JSON for each column_item.
  // Format: {template: <JSON template>, schema: <Schema>}
  // template: consists of slate JSON structure of what's inside each column_item
  // schema: data schema if there's texts or buttons that need to
  //         connect to some data source. Mapping between schema_key to column name in data source
  COLLECTION_TEMPLATE = 'collection_template',
  COLLECTION_DEFAULT_ITEM_PAGE_TEMPLATE_KEY = 'collection_default_item_page_template_key',
  COLLECTION_DATA_ID = 'collection_data_id', // reference to data setup that is saved in space.customization

  // For COLLECITON_ITEM
  COLLECTION_ITEM_ID = 'collection_item_id', // the data id from the table for the current COLLECTION_ITEM
  COLLECTION_ITEM_PAGE_ID = 'collection_item_page_id', // the page id for the item page template for this collection item

  // COLLECTION_CONNECT_DATA and COLLECTION_DATA_SCHEMA_KEY
  // would be part of normal elements that are inside of a collection_template.template
  COLLECTION_CONNECT_DATA = 'collection_connect_data', // boolean, whether or not this element should be connected to a data source
  COLLECTION_CONNECT_DATA_KEYS = 'collection_connect_data_keys', // array of connection setups [{schemaKey: 'title', blockElementKey: 'text'}]

  FORM_ID = 'form_id',
  IS_LABEL_HIDDEN = 'is_label_hidden',
  LABEL = 'label',
  PLACEHOLDER = 'placeholder',
  REQUIRED = 'required',
  INPUT_OPTIONS = 'options',
}
export interface IConnectionDataKey {
  schemaKey: string,
  blockElementKey: BLOCK_ELEMENT_KEY.TEXT
  | BLOCK_ELEMENT_KEY.URL
  | BLOCK_ELEMENT_KEY.BACKGROUND_IMAGE
  | BLOCK_ELEMENT_KEY.HREF
  | BLOCK_ELEMENT_KEY.HTML
  | BLOCK_ELEMENT_KEY.FILE
  ,
}
export interface CollectionDataKeys extends TText, TElement {
  [BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA]?: boolean;
  [BLOCK_ELEMENT_KEY.COLLECTION_CONNECT_DATA_KEYS]?: IConnectionDataKey[];
}
